import { Controller } from '@hotwired/stimulus'

// Onboarding Pricing step: live example strip ("$100 in flowers becomes $X")
// and the Inclusive/Exclusive segmented control writing a hidden field.
export default class extends Controller {
  static targets = ['markup', 'total', 'calcField', 'calcLabel', 'segBtn']

  connect() {
    this.recalculate()
  }

  recalculate() {
    const markup = parseFloat(this.markupTarget.value) || 0
    this.totalTarget.textContent = Math.round(100 * markup)
  }

  setCalc(event) {
    const value = event.currentTarget.dataset.value
    this.calcFieldTarget.value = value
    this.segBtnTargets.forEach((btn) => {
      btn.setAttribute('aria-pressed', btn.dataset.value === value ? 'true' : 'false')
    })
    if (this.hasCalcLabelTarget) this.calcLabelTarget.textContent = value
  }
}
